/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { LftSidePaneActionId } from '../shared';

export const LftSidePaneCreateImageAction = (onClickHandler?: () => void): Action => ({
    id: LftSidePaneActionId.CreateImage,
    checked: false,
    primaryContent: strings.getString('lftSidePaneCreateImageTitle'),
    secondaryContent: strings.getString('lftSidePaneCreateImageContent'),
    onClick: () => {
        onClickHandler?.(); 
    }
});
